<div class="counter-layout-component-container scrollable-component-container">
  <div class="attribute-editor-component">
    <div
      class="scrollable-component-settings te-scrollable-container counter-layout-component-settings"
    >
      <!-- Choose a counter type -->
      <div class="attribute-editor-row">
        <label id="layout-counter-type-label">Choose a counter type</label>
        <div class="form-group layout-selector">
          <div
            class="layout-container"
            role="radiogroup"
            aria-labelledby="layout-counter-type-label"
          >
            <button
              #counterTypeBtn
              type="button"
              class="layout-option counter-type-option"
              [ngClass]="{
                'layout-option--selected': counterType === CounterType.DOWN,
              }"
              (click)="setCounterType(CounterType.DOWN)"
              (keydown)="onCounterTypeKeydown($event, CounterType.DOWN)"
              [attr.aria-checked]="counterType === CounterType.DOWN"
              [attr.tabindex]="
                counterType === CounterType.DOWN || !counterType ? 0 : -1
              "
              role="radio"
            >
              <div class="layout-icon-container counter-type-icon-container">
                <!--
                  Count down: outlined circle (green) with downward arrow.
                  Arrow derived from icon/arrow-left rotated -90°.
                  Down arrow: shaft M16.5 10.5V22.5, head M11 17L16.5 22.5L22 17
                -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 33 33"
                  fill="none"
                >
                  <circle
                    cx="16.5"
                    cy="16.5"
                    r="15"
                    stroke="#1ea861"
                    stroke-width="1.5"
                  />
                  <path
                    d="M16.5 10.5V22.5M11 17l5.5 5.5 5.5-5.5"
                    stroke="#1ea861"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="counter-type-text">
                <div class="layout-label">Count down</div>
                <div class="counter-type-description">
                  Count down to a future date
                </div>
              </div>
            </button>

            <button
              #counterTypeBtn
              type="button"
              class="layout-option counter-type-option"
              [ngClass]="{
                'layout-option--selected': counterType === CounterType.UP,
              }"
              (click)="setCounterType(CounterType.UP)"
              (keydown)="onCounterTypeKeydown($event, CounterType.UP)"
              [attr.aria-checked]="counterType === CounterType.UP"
              [attr.tabindex]="counterType === CounterType.UP ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container counter-type-icon-container">
                <!--
                  Count up: outlined circle (blue) with upward arrow.
                  Arrow derived from icon/arrow-left rotated +90°.
                  Up arrow: shaft M16.5 22.5V10.5, head M11 16l5.5-5.5 5.5 5.5
                -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 33 33"
                  fill="none"
                >
                  <circle
                    cx="16.5"
                    cy="16.5"
                    r="15"
                    stroke="#3B82F6"
                    stroke-width="1.5"
                  />
                  <path
                    d="M16.5 22.5V10.5M11 16l5.5-5.5 5.5 5.5"
                    stroke="#3B82F6"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="counter-type-text">
                <div class="layout-label">Count up</div>
                <div class="counter-type-description">
                  Count up from a past date
                </div>
              </div>
            </button>

            <button
              #counterTypeBtn
              type="button"
              class="layout-option counter-type-option"
              [ngClass]="{
                'layout-option--selected': counterType === CounterType.DAILY,
              }"
              (click)="setCounterType(CounterType.DAILY)"
              (keydown)="onCounterTypeKeydown($event, CounterType.DAILY)"
              [attr.aria-checked]="counterType === CounterType.DAILY"
              [attr.tabindex]="counterType === CounterType.DAILY ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container counter-type-icon-container">
                <!--
                  Repeat daily: exact paths from Figma export (Frame 1321315660).
                  Translated so the circle is centered in a 33×33 viewBox.
                -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 33 33"
                  fill="none"
                >
                  <g transform="translate(-9.483 0.09)">
                    <path
                      d="M30.4958 14.3591L33.3676 11.4873L30.4958 8.61548M33.3676 11.4873L21.8804 11.4874C21.01 11.4874 20.1752 11.8331 19.5597 12.4486C18.9442 13.0641 18.5984 13.899 18.5984 14.7694V16.4104M21.4702 18.4616L18.5984 21.3334L21.4702 24.2052M18.5984 21.3334L30.0856 21.3333C30.956 21.3333 31.7908 20.9876 32.4063 20.3721C33.0218 19.7566 33.3676 18.9218 33.3676 18.0513V16.4103"
                      stroke="#A855F7"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="25.983"
                      cy="16.4103"
                      r="15.5753"
                      stroke="#A855F7"
                      stroke-width="1.67"
                    />
                  </g>
                </svg>
              </div>
              <div class="counter-type-text">
                <div class="layout-label">Repeat daily</div>
                <div class="counter-type-description">
                  Count down to a time every day
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <!-- Target date (hidden for Repeat daily) -->
      @if (counterType !== CounterType.DAILY) {
        <div class="attribute-editor-row">
          <label for="counter-target-date">{{
            counterType === CounterType.UP ? 'Start date' : 'Target date'
          }}</label>
          <mat-form-field
            appearance="outline"
            class="date-picker counter-date-time-field"
          >
            <button
              mat-icon-button
              matPrefix
              type="button"
              (click)="targetDatePicker.open()"
              aria-label="Open date picker"
            >
              <mat-icon svgIcon="calendar"></mat-icon>
            </button>
            <input
              matInput
              [matDatepicker]="targetDatePicker"
              id="counter-target-date"
              name="counterTargetDate"
              [(ngModel)]="targetDate"
              ngDefaultControl
              placeholder="MM/DD/YYYY"
              (dateChange)="save()"
            />
            <mat-datepicker
              #targetDatePicker
              [calendarHeaderComponent]="calendarMonthYearHeader"
              [startAt]="matDatepickerConfig.startAt"
              [startView]="matDatepickerConfig.startView"
            />
          </mat-form-field>
        </div>
      }

      <!-- Target time -->
      <div class="attribute-editor-row">
        <label for="counter-target-time">{{
          counterType === CounterType.UP ? 'Start time' : 'Target time'
        }}</label>
        <mat-form-field
          appearance="outline"
          class="date-picker counter-date-time-field"
        >
          <button
            mat-icon-button
            matPrefix
            type="button"
            aria-label="Select time"
            (click)="targetTimePicker.open()"
          >
            <mat-icon svgIcon="alarm-clock"></mat-icon>
          </button>
          <!-- (change), not (ngModelChange): MatTimepickerInput updates the model
               on every keystroke, so ngModelChange would save() mid-typing on an
               incomplete/invalid value. The native change event only fires on blur.
               (selected) on mat-timepicker below covers overlay-driven picks, which
               never dispatch a native change event on the input. -->
          <input
            matInput
            [matTimepicker]="targetTimePicker"
            id="counter-target-time"
            name="counterTargetTime"
            [(ngModel)]="targetTime"
            ngDefaultControl
            (change)="save()"
          />
          <mat-timepicker
            #targetTimePicker
            interval="15m"
            (selected)="save()"
          />
        </mat-form-field>
      </div>

      <!-- Skip weekends (hidden for daily; not used on time-only path) -->
      @if (counterType !== CounterType.DAILY) {
        <div class="attribute-editor-row">
          <div class="flex-row left-right-aligner form-group">
            <label id="counter-skip-weekends-label" class="mb-0"
              >Skip weekends</label
            >
            <mat-slide-toggle
              class="pl-3"
              [checked]="skipWeekends"
              (change)="setSkipWeekends($event.checked)"
              ariaLabelledby="counter-skip-weekends-label"
            ></mat-slide-toggle>
          </div>
        </div>
      }

      <!-- Completion message (hidden for Count Up — no completion event fires) -->
      @if (counterType !== CounterType.UP) {
        <div class="attribute-editor-row">
          <div class="form-group">
            <label for="counter-completion-message"
              >Completion message (optional)</label
            >
            <input
              type="text"
              id="counter-completion-message"
              name="counterCompletionMessage"
              class="form-control"
              [(ngModel)]="completionMessage"
              placeholder="It's the big day!"
              (change)="save()"
            />
          </div>
        </div>
      }

      <!-- Choose a layout -->
      <div class="attribute-editor-row">
        <label id="layout-counter-layout-label">Choose a layout</label>
        <div class="form-group layout-selector">
          <div
            class="layout-container"
            role="radiogroup"
            aria-labelledby="layout-counter-layout-label"
          >
            <button
              #layoutOptionBtn
              type="button"
              class="layout-option"
              [ngClass]="{
                'layout-option--selected': layout === LayoutType.SQUARES,
              }"
              (click)="setLayout(LayoutType.SQUARES)"
              (keydown)="onLayoutKeydown($event, LayoutType.SQUARES)"
              [attr.aria-checked]="layout === LayoutType.SQUARES"
              [attr.tabindex]="
                layout === LayoutType.SQUARES || !layout ? 0 : -1
              "
              role="radio"
            >
              <div class="layout-icon-container">
                <!-- Squares: 3 square boxes with drop shadows (from Figma node 7220:9717) -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 96 40"
                  fill="none"
                  overflow="visible"
                >
                  <defs>
                    <filter
                      id="sq-shadow"
                      x="-30%"
                      y="-30%"
                      width="160%"
                      height="160%"
                    >
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="3"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="2"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                    </filter>
                  </defs>
                  <!-- Square 1 -->
                  <rect
                    x="0"
                    y="7"
                    width="26"
                    height="26"
                    rx="2"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#sq-shadow)"
                  />
                  <text
                    x="13"
                    y="25"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="11"
                    font-weight="500"
                    fill="#3c4653"
                  >
                    4
                  </text>
                  <!-- Square 2 -->
                  <rect
                    x="35"
                    y="7"
                    width="26"
                    height="26"
                    rx="2"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#sq-shadow)"
                  />
                  <text
                    x="48"
                    y="25"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="11"
                    font-weight="500"
                    fill="#3c4653"
                  >
                    12
                  </text>
                  <!-- Square 3 -->
                  <rect
                    x="70"
                    y="7"
                    width="26"
                    height="26"
                    rx="2"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#sq-shadow)"
                  />
                  <text
                    x="83"
                    y="25"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="11"
                    font-weight="500"
                    fill="#3c4653"
                  >
                    36
                  </text>
                </svg>
              </div>
              <div class="layout-label">Squares</div>
            </button>

            <button
              #layoutOptionBtn
              type="button"
              class="layout-option"
              [ngClass]="{
                'layout-option--selected': layout === LayoutType.CIRCLES,
              }"
              (click)="setLayout(LayoutType.CIRCLES)"
              (keydown)="onLayoutKeydown($event, LayoutType.CIRCLES)"
              [attr.aria-checked]="layout === LayoutType.CIRCLES"
              [attr.tabindex]="layout === LayoutType.CIRCLES ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container">
                <!-- Circles: 3 circle boxes with drop shadows (from Figma node 7220:9731) -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 96 40"
                  fill="none"
                  overflow="visible"
                >
                  <defs>
                    <filter
                      id="ci-shadow"
                      x="-30%"
                      y="-30%"
                      width="160%"
                      height="160%"
                    >
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="3"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="2"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                    </filter>
                  </defs>
                  <!-- Circle 1 -->
                  <circle
                    cx="13"
                    cy="20"
                    r="13"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#ci-shadow)"
                  />
                  <text
                    x="13"
                    y="25"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="11"
                    font-weight="500"
                    fill="#3c4653"
                  >
                    4
                  </text>
                  <!-- Circle 2 -->
                  <circle
                    cx="48"
                    cy="20"
                    r="13"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#ci-shadow)"
                  />
                  <text
                    x="48"
                    y="25"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="11"
                    font-weight="500"
                    fill="#3c4653"
                  >
                    12
                  </text>
                  <!-- Circle 3 -->
                  <circle
                    cx="83"
                    cy="20"
                    r="13"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#ci-shadow)"
                  />
                  <text
                    x="83"
                    y="25"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="11"
                    font-weight="500"
                    fill="#3c4653"
                  >
                    36
                  </text>
                </svg>
              </div>
              <div class="layout-label">Circles</div>
            </button>

            <button
              #layoutOptionBtn
              type="button"
              class="layout-option"
              [ngClass]="{
                'layout-option--selected': layout === LayoutType.HORIZONTAL,
              }"
              (click)="setLayout(LayoutType.HORIZONTAL)"
              (keydown)="onLayoutKeydown($event, LayoutType.HORIZONTAL)"
              [attr.aria-checked]="layout === LayoutType.HORIZONTAL"
              [attr.tabindex]="layout === LayoutType.HORIZONTAL ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container">
                <!-- Horizontal: single wide bar with 12 HRS 36 MIN (from Figma node 7220:9745) -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 96 40"
                  fill="none"
                  overflow="visible"
                >
                  <defs>
                    <filter
                      id="hz-shadow"
                      x="-20%"
                      y="-50%"
                      width="140%"
                      height="200%"
                    >
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="3"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                      <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="2"
                        flood-color="#94A3B8"
                        flood-opacity="0.2"
                      />
                    </filter>
                  </defs>
                  <rect
                    x="6"
                    y="12"
                    width="84"
                    height="16"
                    rx="2"
                    fill="white"
                    stroke="rgba(57,76,96,0.06)"
                    stroke-width="0.5"
                    filter="url(#hz-shadow)"
                  />
                  <text
                    x="20"
                    y="24"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="10"
                    font-weight="700"
                    fill="#3c4653"
                  >
                    12
                  </text>
                  <text
                    x="31"
                    y="24"
                    text-anchor="start"
                    font-family="Inter, sans-serif"
                    font-size="7"
                    font-weight="500"
                    fill="#4b5563"
                  >
                    HRS
                  </text>
                  <text
                    x="54"
                    y="24"
                    text-anchor="middle"
                    font-family="Inter, sans-serif"
                    font-size="10"
                    font-weight="700"
                    fill="#3c4653"
                  >
                    36
                  </text>
                  <text
                    x="65"
                    y="24"
                    text-anchor="start"
                    font-family="Inter, sans-serif"
                    font-size="7"
                    font-weight="500"
                    fill="#4b5563"
                  >
                    MIN
                  </text>
                </svg>
              </div>
              <div class="layout-label">Horizontal</div>
            </button>
          </div>
        </div>
      </div>

      <!-- Colors -->
      <div class="attribute-editor-row tw-mt-[20px]">
        <p class="counter-layout-section-heading">Colors</p>
        <div class="form-group">
          <div class="flex-row left-right-aligner pt-3">
            <span
              id="counter-color-label-text"
              class="counter-layout-color-label"
              >Text</span
            >
            <color-picker
              pickerId="te-layout-counter-text-color"
              ariaLabelledby="counter-color-label-text"
              [(ngModel)]="textColor"
              (change)="save()"
              ngDefaultControl
            ></color-picker>
          </div>
        </div>
        <div class="form-group">
          <div class="flex-row left-right-aligner pt-3">
            <span id="counter-color-label-bg" class="counter-layout-color-label"
              >Background</span
            >
            <color-picker
              pickerId="te-layout-counter-bg-color"
              ariaLabelledby="counter-color-label-bg"
              [(ngModel)]="backgroundColor"
              (change)="save()"
              ngDefaultControl
            ></color-picker>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="attribute-editor-row">
        <p class="counter-layout-section-heading">Content</p>
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label id="counter-show-labels-label" class="mb-0 control-label"
            >Show labels</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showLabels"
            (change)="setShowLabels($event.checked)"
            ariaLabelledby="counter-show-labels-label"
          ></mat-slide-toggle>
        </div>
        @if (counterType !== CounterType.DAILY) {
          <div class="flex-row left-right-aligner pt-3 form-group">
            <label id="counter-show-hours-label" class="mb-0 control-label"
              >Show hours</label
            >
            <mat-slide-toggle
              class="pl-3"
              [checked]="showHours"
              (change)="setShowHours($event.checked)"
              ariaLabelledby="counter-show-hours-label"
            ></mat-slide-toggle>
          </div>
        }
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label id="counter-show-minutes-label" class="mb-0 control-label"
            >Show minutes</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showMinutes"
            (change)="setShowMinutes($event.checked)"
            ariaLabelledby="counter-show-minutes-label"
          ></mat-slide-toggle>
        </div>
        <div class="flex-row left-right-aligner pt-3 form-group">
          <label id="counter-show-seconds-label" class="mb-0 control-label"
            >Show seconds</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="showSeconds"
            (change)="setShowSeconds($event.checked)"
            ariaLabelledby="counter-show-seconds-label"
          ></mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
</div>
